import React from "react";

const IndicatorGauge = ({ 
  value = 30, 
  maxValue = 100,
  title = "Indicador de HES",
  description = "Tu nivel de cumplimiento es de",
  size = 220,
  loading = false,
}) => {
  const percentage = (value / maxValue) * 100;
  
  const angle = 180 - (percentage / 100) * 180;

  const endX = 50 + 45 * Math.cos((angle * Math.PI) / 180);
  const endY = 50 - 45 * Math.sin((angle * Math.PI) / 180);

  const lineLength = 10;
  const lineX1 = endX - lineLength * Math.cos((angle * Math.PI) / 180);
  const lineY1 = endY + lineLength * Math.sin((angle * Math.PI) / 180);
  const lineX2 = endX + lineLength * Math.cos((angle * Math.PI) / 180);
  const lineY2 = endY - lineLength * Math.sin((angle * Math.PI) / 180);

  const getColor = () => {
    if (percentage <= 50) return "#E32533"; // Rojo
    if (percentage <= 75) return "#FFC000"; // Amarillo
    return "#769B40"; // Verde
  };

  const currentColor = getColor();

  if (loading) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <div className="w-6 h-6 border-2 border-gray-300 rounded-full animate-spin border-t-transparent" />
        <p className="ml-3 text-gray-500">Cargando...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full justify-between items-center gap-3 p-4 bg-white rounded-[10px] shadow-lg">
      {title && <h3 className="text-base text-center font-itcbold text-blue">{title}</h3>}

      <div className="relative" style={{ width: size, height: size / 2 }}>
        {/* SVG para la barra de progreso */}
        <svg width={size} height={size / 2} viewBox="0 0 100 50">
          {/* Capa de fondo con grosor normal (5) */}
          <path
            d="M 5 50 A 45 45 0 0 1 50 5"
            stroke="#E32533"  // Rojo
            strokeWidth="5"
            fill="none"
          />
          <path
            d="M 50 5 A 45 45 0 0 1 84 20"
            stroke="#FFC000"  // Amarillo
            strokeWidth="5"
            fill="none"
          />
          <path
            d="M 84 20 A 45 45 0 0 1 95 50"
            stroke="#769B40"  // Verde
            strokeWidth="5"
            fill="none"
          />

          {/* Capa superior con grosor mayor (10) hasta el porcentaje actual */}
          <path
            d={`M 5 50 A 45 45 0 0 1 ${endX} ${endY}`}
            stroke={percentage <= 50 ? "#E32533" : percentage <= 75 ? "#FFC000" : "#769B40"}
            strokeWidth="10"
            fill="none"
          />

<line
            x1={lineX1}
            y1={lineY1}
            x2={lineX2}
            y2={lineY2}
            stroke={currentColor}
            strokeWidth="0.5"
          />

        </svg>
        <div className="absolute bottom-0 flex items-center justify-center w-full">
            <p className="text-blue font-itcbold text-[30px]">{value}%</p>
        </div>
      </div>


      {description && (
        <p className="text-sm font-itcmedium text-center text-[#111928]">
          {description} {''} {value}% del {maxValue}%
        </p>
      )}
    </div>
  );
};

export default IndicatorGauge;